import { useState, useCallback, useEffect } from 'react'
import moment from 'moment';
import { Avatar, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, Divider, Grid, Skeleton, Theme, Typography, useTheme } from '@mui/material'

import { PlusIcon } from '../../../../assets/SvgIcons'
import { useHistory } from 'react-router'
import AddBankModal from '../../common/AddBankModal'
import { useDispatch, useSelector } from "react-redux";
import { getMandateCreationDetails, getMandateRegistered, getMandatesList } from '../../../../redux-store/actions/investorProfile'
import { GetMandateCreationDetailsResponseBody, GetMandateRegisteredResponseBody, MandateCreation, MandateListItem, MandatesListResBody } from '../../../../redux-store/types/investorProfile'
import { toINR, isFamilyView, isRMLikeRole } from '../../../../utils/utilityFunctions'
import React from 'react'
import { navigationData } from '../../types';
import { RootStateType } from '../../../../redux-store/reducers';
import { showError } from '../../../../redux-store/actions/auth';
import { HELDAWAY_PORTFOLIO_STATUS, USER_ROLES, WAITING_FOR_CLIENT_AUTHENTICATION } from '../../../../utils/constant';
import dayjs from 'dayjs';
import { Hidden } from '@mui/material';

interface Values {
    amount: string;
    accountNo: string;
    ifscCode: string;
    bankName: string;
    startDate?: string;
    endDate?: string;
    // months: string;
}

// const tabList = ['All', 'Active', 'Under Process']


function Mandates(props: navigationData): JSX.Element {
    const { clientCode } = props
    const history = useHistory();
    const { pathname: pathName, state } = history.location
    const { role = '' } = useSelector((store: RootStateType) => store.auth);
    const dispatch = useDispatch();
    const { palette, typography } = useTheme()
    const [open, setOpen] = useState<boolean>(false);
    const [bankMandateDetailsRes, setBankMandateDetailsRes] = useState<Array<MandateCreation>>([]);
    const [mandateRequestDialog, setMandateRequestDialog] = useState<boolean>(false);
    const [mandateFormValues, setMandateFormValues] = useState<Values>({
        amount: '',
        accountNo: '',
        ifscCode: '',
        bankName: '',
        startDate: '',
        endDate: '',

        // months: ''
    });

    const [registerMandateRes, setRegisterMandateRes] = useState({})
    const [bankMandatesList, setBankMandatesList] = useState<Array<MandateListItem>>([]);
    const [filteredList, setFilteredList] = useState<Array<MandateListItem>>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [fileId, setFileId] = useState<string>('');
    const [tabList, setTabList] = useState([{
        label: 'All',
        count: 0,
    }, {
        label: 'Active',
        count: 0,
    }, {
        label: 'Under Process',
        count: 0,
    },]);
    const [activeTab, setActiveTab] = useState(tabList[0].label)

    const { selectedPortfolio, isPortfolioHeldaway } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const { investorClientId, viewAsFamilyId = "" } = useSelector((state: RootStateType) => state.id)

    // console.log('clientCode', clientCode)
    const familyClientCode = isRMLikeRole(role) ? props?.clientCode : isFamilyView(pathName) ? viewAsFamilyId : investorClientId;
    const clientCodePayload = {
        clientCode: familyClientCode,
        portfolioId: selectedPortfolio?.value
    }

    const handleTabClick = (value: string) => {
        console.log('value', value)

        setActiveTab(value)
        if (value === 'All') {
            setBankMandatesList(filteredList);
        }
        else if (value === 'Active') {
            const checkValue = 'approved';
            setBankMandatesList(filteredList?.filter((item) => item.status?.toLowerCase() === checkValue))
        }
        else if (value === 'Under Process') {
            const mandatesUnderProcess = filteredList?.filter((item) => item.status?.toLowerCase() !== 'approved');
            setBankMandatesList(mandatesUnderProcess);
        }
    }

    const handleBankClose = useCallback((elogString: string) => {
        setOpen(false)
        if (elogString !== "close" && elogString !== "")
            window.open(elogString, '_blank');
    }, [])

    const handleMandateModal = async () => {
        if (isPortfolioHeldaway) {
            dispatch(showError(HELDAWAY_PORTFOLIO_STATUS))
            return
        }

        setOpen(true);
    }

    const actype = bankMandateDetailsRes?.[0]?.bankAccountType === "SAVING" ? "1" : "2";

    const transformItem = (item: any) => {
        return {
            ...item,
            loading,
            clientCode
        }
    }

    useEffect(() => {
        const fetchInitialMandates = async () => {
            try {
                setLoading(true);
                const list = await (dispatch(getMandatesList(clientCodePayload)) as unknown as Promise<MandatesListResBody>);
                setBankMandatesList(list?.mandates || []);
                setFilteredList(list?.mandates || []);
                setTabList([
                    {
                        label: 'All',
                        count: list?.mandates?.length ?? 0
                    },
                    {
                        label: 'Active',
                        count: list?.mandates?.filter((item) => item.status === 'APPROVED')?.length ?? 0
                    },
                    {
                        label: 'Under Process',
                        count: list?.mandates?.filter((item) => item.status !== 'APPROVED')?.length ?? 0
                    },
                ])
            } catch (e) {
                console.log("Error", e);
            } finally {
                setLoading(false);
            }
        }
        if (!open) fetchInitialMandates();
    }, [open])




    return (
        <Box
            sx={{
                background: palette.common.white,
                borderRadius: '25px',
                padding: { xs: '15px', sm: '35px' }
            }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{
                    ...typography.h2,
                    color: palette.text.primary
                }}>Bank Mandates</Typography>
                <Box component={'button'}
                    onClick={handleMandateModal}
                    disabled={isFamilyView(pathName)}
                    sx={{
                        cursor: isFamilyView(pathName) ? 'not-allowed' : 'pointer',
                        outline: 'none',
                        border: 'none',
                        background: isFamilyView(pathName) ? palette.text.secondary : palette.primary[500],
                        borderRadius: '10px',
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '10px',
                        alignItems: 'center',
                        padding: { xs: '8px 12px', md: '15px' },
                        opacity: isFamilyView(pathName) ? 0.6 : 1,
                    }}>
                    <PlusIcon />
                    <Typography sx={(theme: Theme) => (
                        {
                            fontSize: ['14px', '16px'],
                            // ...typography.subtitle_500,
                            fontWeight: [500, 600],
                            // fontWeight:600
                            color: palette.common.white
                        }
                    )}>Create<Hidden mdDown> a new Mandate </Hidden></Typography>
                </Box>
            </Box>
            <Box>
                <Typography variant='subtitle_400' color={palette.text.secondary} fontSize={{ lg: '16px', md: '16px', sm: '14px', xs: '14px' }}>
                    <Typography variant='body_500' color={palette.primary[500]} fontWeight={600} component={'span'}>Note: </Typography>
                     The mandate status will be updated within 24 hours after authentication. If it has already been authenticated, please wait for the update.
                </Typography>
            </Box>
            {/* #30 */}
            <Box sx={{ marginTop: '20px' }}>
                <Box
                    role="tablist"
                    sx={{
                        borderBottom: `1px solid ${palette.text.secondary}99`,
                        display: 'flex',
                        flexDirection: {
                            xs: 'row',
                            sm: 'row',
                        },
                        flexWrap: 'wrap',
                        gap: '8px',
                    }}
                >
                    {tabList.map((item, index) => (
                        <Button
                            key={index + item?.label}
                            id={`mandates-tab-${(item?.label ?? '').replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}
                            role="tab"
                            aria-controls={`mandates-tabpanel-${(item?.label ?? '').replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}
                            aria-selected={activeTab === item?.label}
                            onClick={() => activeTab !== item?.label && handleTabClick(item?.label)}
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: '6px',
                                background: activeTab === item?.label ? palette.primary[500] : palette.grey[50],
                                borderRadius: '8px',
                                padding: {
                                    xs: '8px',
                                    md: '5px 15px',
                                },
                                cursor: 'pointer',
                                minWidth: {
                                    xs: '100px',
                                    sm: 'auto',
                                },
                                justifyContent: 'center',
                                alignItems: 'center',
                                flex: {
                                    xs: '1 1 calc(50% - 8px)',
                                    sm: 'unset',
                                },
                            }}
                        >
                            <Typography
                                color={activeTab === item?.label ? palette.textDark.primary : palette.text.secondary}
                                variant="body_500"
                                sx={{ textAlign: 'center' }}
                            >
                                {item?.label}
                            </Typography>
                            <Typography
                                component="span"
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    padding: '0px 8px',
                                    backgroundColor: activeTab === item?.label
                                        ? theme.palette.common.white
                                        : theme.palette.primary[100],
                                    color: theme.palette.primary[500],
                                    borderRadius: '7px',
                                    letterSpacing: '0.02px',
                                })}
                            >
                                {item?.count}
                            </Typography>
                        </Button>
                    ))}
                </Box>
            </Box>

            <Box
                id={`mandates-tabpanel-${(activeTab ?? '').replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}
                role="tabpanel"
                aria-labelledby={`mandates-tab-${(activeTab ?? '').replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}
                sx={{ marginTop: '25px', display: 'flex', flexDirection: 'column', gap: '35px' }}>
                {loading ? (
                    [...Array(3)].map((item, index) => (
                        <Box key={index}>

                            <Box >
                                <Box sx={{
                                    background: palette.grey[50],
                                    padding: '25px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                }}>
                                    {/* fund details */}
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '15px' }}>
                                        <Skeleton animation="wave" variant='rectangular' width={'45px'} height={'45px'} sx={{ borderRadius: '50%' }} />
                                        <Box>
                                            <Skeleton animation="wave" sx={{ width: { xs: '50px', sm: '120px' } }} />
                                            <Skeleton animation="wave" sx={{ width: { xs: '20px', sm: '80px' } }} />
                                        </Box>

                                        <Box sx={{ ml: '10px' }}>
                                            <Skeleton animation="wave" sx={{ width: { xs: '50px', sm: '120px' } }} />
                                            <Skeleton animation="wave" sx={{ width: { xs: '20px', sm: '80px' } }} />
                                        </Box>
                                    </Box>
                                    <Box sx={{ ml: { xs: '3px', sm: '50px' }, width: { xs: '50px', sm: '250px' }, height: { xs: '30px', sm: '50px' } }}>
                                        <Skeleton animation="wave" variant='rectangular' />
                                    </Box>
                                    {/* list for details */}
                                </Box>
                            </Box>
                            <Grid container mt={'25px'} pr={'25px'} pl={'25px'} rowGap={{ lg: '45px', md: '20px', sm: '20px', xs: '10px' }} >
                                {[...Array(8)].map((item, index) => (
                                    <Grid key={index} item lg={3} md={4} sm={6} xs={12}>
                                        <Box>
                                            <Skeleton animation="wave" sx={{ width: '120px' }} />
                                            <Skeleton animation="wave" sx={{ width: '60px' }} />
                                        </Box>
                                    </Grid>

                                ))}
                            </Grid>

                        </Box>
                    ))
                )
                    : bankMandatesList?.length === 0 ? (
                        <Typography sx={{ textAlign: 'center', mt: '20px' }} variant='h2' color={'text.primary'}> No Results Found</Typography>
                    ) : bankMandatesList?.filter(item => item.accountType !== null).map((item, index) => (
                        <div key={index}>
                            <Card {...transformItem(item)} />
                            {bankMandatesList?.length - 1 !== index && <Divider sx={{ marginTop: '20px' }} />}
                        </div>
                    )
                    )}


            </Box>
            {open &&
                <AddBankModal
                    {...{
                        handleClose: handleBankClose,
                        open,
                        setOpen,
                        setActiveTab,
                        title: 'Add New Bank Mandate',
                        // bankMandateDetails: bankMandateDetailsRes,
                        clientCode: clientCode,
                        mandateRequestDialog,
                        setMandateRequestDialog,
                        mandateFormValues,
                        setMandateFormValues,


                    }}
                />
            }

        </Box>
    )
}

export default Mandates

type CardProps = {
    loading?: boolean,
    mandateId: string,
    months: string,
    mandateType: string,
    amount: string,
    accountNo: string,
    ifscCode: string,
    bankName: string,
    status: string,
    fileKey: string,
    accountType: string,
    uploadFlag: boolean | null,
    startDate: string
    clientCode: string;
    uploadKey: boolean;
    endDate?: string;
    bseEmandateURL?: string;
    createdAt?: string
}

const Card = (props: CardProps) => {
    const { mandateId, months, status, mandateType, amount, accountNo, bankName, ifscCode, fileKey, accountType, uploadFlag, startDate, clientCode, uploadKey, endDate, bseEmandateURL,createdAt } = props
    const { palette, typography } = useTheme()
    const history = useHistory();
    const { pathname: pathName, state } = history.location;

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const formUploaded = (state as { formUploaded?: boolean })?.formUploaded ?? false;

     const isBseAuthenticateUrl = `${bseEmandateURL ?? ''}`?.startsWith('https://');

    const handleAuthenticateMandate = () => {
        window.open(`${bseEmandateURL}`, '_blank')
    }
    return (
        <Box>
            <Box sx={{
                background: palette.grey[50],
                padding: { xs: '10px', sm: '20px' },
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                flexWrap: 'wrap'
            }}>
                {/* fund details */}
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '15px' }}>
                    <Avatar sx={{ width: '45px', height: '45px', borderRadius: "0px" }} alt='fund icon' src='/images/amcIcons/default.svg' />
                    <Box >
                        <Typography sx={{
                            ...typography.subtitle_300,
                            fontWeight: 500,
                            color: palette.text.secondary
                        }}>Reference ID</Typography>
                        <Typography sx={{
                            ...typography.subtitle_300,
                            fontWeight: 600,
                            color: palette.text.primary
                        }}>{mandateId}</Typography>
                    </Box>
                    <Box sx={{ ml: { xs: '15px', sm: '50px' } }}>
                        <Typography sx={{
                            ...typography.subtitle_300,
                            fontWeight: 500,
                            color: palette.text.secondary
                        }}>Mandate Creation Date</Typography>
                        <Typography sx={{
                            ...typography.subtitle_300,
                            fontWeight: 600,
                            color: palette.text.primary
                        }}>{moment(createdAt, "YYYY-MM-DD HH:mm:ss.SSSZ").format("DD/MM/YYYY")}</Typography>
                    </Box>
                </Box>
                {mandateType !== "N" && (
                    <Box sx={{ display: { xs: 'none', sm: 'unset' } }}>

                        <Button disabled={mandateType === "N" || uploadKey === true} sx={{ cursor: 'pointer', outline: 'none', border: mandateType === "N" || uploadKey === true ? `1px solid ${palette.textDark.secondary}` : `1px solid ${palette.primary[500]}`, padding: '15px', borderRadius: '4px', }}
                            onClick={() => history.push(`${pathName}/download-upload-xsip`, { downloadUploadFixture: { ...props, fileKey }, clientCode: clientCode })}
                        >
                            <Typography sx={{
                                ...typography.subtitle_300,
                                fontWeight: 600,
                                color: mandateType === "N" || uploadKey === true ? palette.textDark.secondary : palette.primary[500]
                            }}>Download and Upload XSIP Form</Typography>
                        </Button>

                    </Box>
                )
                }
                {bseEmandateURL && bseEmandateURL?.startsWith('https') && status === WAITING_FOR_CLIENT_AUTHENTICATION && (
                    <Button
                        variant='contained'
                        sx={{
                            cursor: 'pointer',
                            outline: 'none',
                            display: { xs: 'none', sm: 'flex' },
                            padding: { xs: '5px 10px', sm: '0px 10px' },
                            borderRadius: '10px',
                            mt: { xs: '10px', sm: '0px' },
                            ml: { xs: '10px', sm: '15px' },
                        }}
                        onClick={handleAuthenticateMandate}
                    >
                        <Typography
                            variant='overline_600'>
                            Authenticate <Hidden smDown>Now</Hidden>
                        </Typography>
                    </Button>
                )}
                {/* list for details */}
            </Box>
            <Grid container mt="25px" rowGap="15px" sx={{ flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { sm: 'left' } }}>
                    <Item title='Mandate Type' subTitle={mandateType === "X" ? "XSIP" : "E-Mandate"} />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { xs: 'left' } }}>
                    <Item title='Status' subTitle={status === "APPROVED" ? 'Active' : status} subTitleColor={status === "APPROVED" ? palette.success[500] : palette.warning[500]} />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { sm: 'center', xs: 'left' } }}>
                    <Item title='Mandate Limit' subTitle={toINR({ value: amount, locale, currencyCode })} />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { sm: 'right', xs: 'left' } }}>
                    <Item title='No. of Months' subTitle={months} subTitleAlign="right" />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' } }}>
                    <Item title='Bank' subTitle={bankName} />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { lg: 'left', xs: 'left' } }}>
                    <Item title='Account Number' subTitle={accountNo} />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { lg: 'center', xs: 'center' } }}>
                    <Item title='Account Type' subTitle={accountType} />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { sm: 'right', xs: 'left' } }}>
                    <Item title='IFSC Code' subTitle={ifscCode} titleAlign="right" />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: 'left' }}>
                    <Item title='Start Date' subTitle={dayjs(startDate).format("DD/MM/YYYY")} titleAlign="left" />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' } }}>
                    <Item title='End Date' subTitle={dayjs(endDate).format("DD/MM/YYYY")} titleAlign="left" />
                </Grid>

                {mandateType !== "N" &&
                    (
                        <Box sx={{ display: { sm: 'none' }, mt: { xs: 2, sm: 0 }, textAlign: 'center', width: "100%" }}>
                            <Button disabled={mandateType === "N" || uploadFlag === true} sx={{ cursor: 'pointer', outline: 'none', border: mandateType === "N" || uploadFlag === true ? `1px solid ${palette.textDark.secondary}` : `1px solid ${palette.primary[500]}`, padding: '10px', borderRadius: '4px', width: "100%" }}
                                onClick={() => history.push(`${pathName}/download-upload-xsip`, { downloadUploadFixture: { ...props, fileKey, clientCode: clientCode } })}
                            >
                                <Typography sx={{
                                    ...typography.subtitle_300,
                                    fontWeight: 600,
                                    color: mandateType === "N" || uploadFlag === true ? palette.textDark.secondary : palette.primary[500]
                                }}>Download and Upload XSIP Form</Typography>
                            </Button>
                        </Box>
                    )
                }
                {bseEmandateURL && bseEmandateURL?.startsWith('https') && status === WAITING_FOR_CLIENT_AUTHENTICATION && (
                    <Button
                        variant='contained'
                          disabled={!isBseAuthenticateUrl}
                        sx={{
                            cursor: 'pointer',
                            outline: 'none',
                            display: { sm: 'none' },
                            padding: '5px 10px',
                            borderRadius: '5px',
                            mt: '10px',
                            width: '100%'
                        }}
                        onClick={handleAuthenticateMandate}
                    >
                        <Typography
                            variant='overline_600'>
                            Authenticate Now
                        </Typography>
                    </Button>
                )}
            </Grid>
        </Box>
    )
}

type ItemProps = {
    title: string
    subTitle: string
    subTitleColor?: string
    subTitleAlign?: 'left' | 'right' | 'center'
    titleAlign?: 'left' | 'right' | 'center',
}

const Item = (props: ItemProps) => {
    const { palette, typography } = useTheme()

    return (
        <Box sx={{ display: { xs: 'flex', sm: 'unset' }, alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography
                sx={{
                    ...typography.body_500,
                    color: palette.text.secondary,
                    display: { xs: 'flex', sm: 'flex' },
                    justifyContent: { xs: 'space-between', sm: props.titleAlign ? props.titleAlign : 'left' }
                }}>
                {props.title}
            </Typography>
            <Typography
                sx={{
                    ...typography.subtitle_300,
                    fontWeight: 600,
                    color: props.subTitleColor ? props.subTitleColor : palette.text.primary,
                    display: { xs: 'flex', sm: 'flex' },
                    justifyContent: { xs: 'space-between', sm: props.subTitleAlign ? props.subTitleAlign : 'left' }
                }}>
                {props.subTitle}
            </Typography>
        </Box>
    )
}